import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  "https://huugjsgnynoslncayaew.supabase.co",   // Project URL
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1dWdqc2dueW5vc2xuY2F5YWV3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg1NjY1NjAsImV4cCI6MjA4NDE0MjU2MH0.v8MV9pcNqkUUcBFbbmcpgFUF5fespy_Zsu9w0iecSl4"            // anon key
);

export const uploadAudioToSupabase = async (audioBlob, tableId) => {
  const fileName = `audio/${tableId}/instruction_${Date.now()}.webm`;

  const { data, error } = await supabase.storage
    .from("Audio")
    .upload(fileName, audioBlob, {
      contentType: "audio/webm",
      upsert: true,
    });

  if (error) {
    console.error("Upload failed:", error);
    return null;
  }

  const { data: urlData } = supabase.storage
    .from("Audio")
    .getPublicUrl(fileName);

  return urlData.publicUrl;
};
